
<div>
  <align class="header" flex>
    <div class="title-block">
      <h3 class="secondary-font">
        Monthly Volume
      </h3>

      <p class="description">
        The total amount of money spent on cards and sealed wax each month. Note this does NOT include memorabilia, tickets, etc.
      </p>
    </div>

    <icon-link @click.native="viewIndustry">
      View More
    </icon-link>
  </align>

  <graph-overview
    graph-only
    month-labels
    :graph-values="[monthlyVolumeTotal]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</div>
